import React, {useState} from 'react';
import {EmbeddedVideo} from 'app/components/tv/EmbeddedVideo';
import VideoPreview from 'app/components/tv/preview/VideoPreview';
import WatchedEmbed from 'app/components/tv/utils/WatchedEmbed';
import DateModel from 'app/models/DateModel';
import {useParams} from 'react-router';

export const EmbedTeaser = ({video}) => {
  const [open, setOpen] = useState(false);
  const isWatched = new WatchedEmbed(video.id).isWatched();
  const {matchSlug} = useParams();

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <VideoPreview
          thumbnail={video.thumbnail}
          updated={!isWatched}
          source={video.data.source}
          title={video.data.source}
          caption={DateModel.fromTimestamp(video.updatedAt * 1000).getRelativeTime()}
        />
      </div>
      <EmbeddedVideo open={open} onClose={() => setOpen(false)} embedData={{matchSlug, ...video.data}} />
    </>
  );
};
